import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M23 6H1v12h22V6zm-2 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
}), 'StraightenSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/StraightenSharp.js
// module id = 6536
// module chunks = 2